module.exports = __webpack_public_path__ + "static/ogp-2dd44fc59f36e4324664660232663bfe.png";